import { faMinus, faPlus, faXmark, faEquals } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  BtnClose, DivIcon, Dialog
  , DialogContent, DialogTitle, Line, MLabel, Overlay
  , TextContent
  , TextTile,
  InputText
} from './styles'
import { Box, Button, Stack } from "@mui/material";
import { INV_GOODS_CHANGE_MODE, MESSAGE } from "Common";
import inventoryApi from "api/inventoryApi";

const DialogChangeInvGoods = ({ txtTitle, invGoods, changeFlg, handleClose, setIsLoading, setReload, setMessage }) => {
  const [quantity, setQuantity] = useState(0);
  const qResult = parseInt(invGoods?.StockQ || 0) + parseInt(quantity) * (changeFlg === INV_GOODS_CHANGE_MODE.ADD ? 1 : -1);

  const handleDialogClose = () => {
    setQuantity(0);
    handleClose();
  }

  const handleRegister = async () => {
    //登録処理
    try {
      setIsLoading(true);
      /**Call Api */
      const params = {
        invGoodsID: invGoods?.ClientInventoryGoodsID || 0,
        numberQ: quantity * (changeFlg === INV_GOODS_CHANGE_MODE.ADD ? 1 : -1)
      }
      const res = await inventoryApi.changeInvGoodsStockQ(params);
      const HistoryID = parseInt(res?.data?.HistoryID || 0);
      if (HistoryID < 1) {
        const msg = {
          contents: ['在庫数の変更に失敗しました。'],
          type: MESSAGE.ERROR
        }
        setMessage(msg);
      }
      // setInvGoods({});
      // setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.NONE);

      //reload
      setReload(prev => !prev);
    } catch (error) {
      const msg = {
        contents: [error],
        type: MESSAGE.ERROR
      }
      setMessage(msg);
    } finally {
      setIsLoading(false);
      handleDialogClose();
    }

  }

  return <>
    {invGoods?.ClientInventoryGoodsID && (<>
      <Dialog>
        <DialogTitle>
          <TextTile>{txtTitle}</TextTile>
          <BtnClose onClick={() => { handleDialogClose(); }}><FontAwesomeIcon icon={faXmark} /></BtnClose>
        </DialogTitle>
        <DialogContent>
          <TextContent>
            <Line>
              <MLabel>商品：</MLabel>{invGoods.GoodsName || '―'}
            </Line>
            <Line>
              <MLabel>サイズ：</MLabel>{invGoods.GoodsSize || '-'}
            </Line>
            <Line>
              <MLabel>現在在庫：</MLabel>{(invGoods.StockQ + (invGoods.StockQMemo || "")) || '-'}
            </Line>
          </TextContent>
          <Box my={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <DivIcon>
                {changeFlg === INV_GOODS_CHANGE_MODE.ADD
                  ? <FontAwesomeIcon icon={faPlus} />
                  : <FontAwesomeIcon icon={faMinus} />}
              </DivIcon>
              <InputText id={'quantity'} value={quantity === 0 ? "" : quantity}
                autoComplete="off"
                onChange={(e) => {
                  const val = parseInt(e.target.value) || 0;
                  setQuantity(val);
                }} />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center" mt={1}>
              <DivIcon><FontAwesomeIcon icon={faEquals} /></DivIcon>
              <InputText id={'qResult'} value={qResult} readOnly
                style={{ borderColor: qResult < 0 ? "#ff0000" : "gray", backgroundColor: "#f5f5f5" }} />
            </Stack>
          </Box>
          <Button variant="contained" color="primary"
            onClick={() => { handleRegister(); }}
            sx={{ minWidth: "120px", fontSize: "1.2rem", fontWeight: "bold", backgroundColor: "#009527" }}
            disabled={quantity === 0 || qResult < 0}

          >登録</Button>
        </DialogContent>
      </Dialog>
      <Overlay /></>)}
  </>;
};

export default DialogChangeInvGoods
